/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const';
import { Col, ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';
import CModalWindow from '../common/modal/modalWindow.component.container';

class ParticipantDetailsChangeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      studyGid: this.props.participantJourney ? this.props.participantJourney.studyGid : null,
      subjectNumber: this.props.participantJourney ? this.props.participantJourney.subjectNumber : null,
      reason: null
    };
    this.handleSubjectNumberChange = this.handleSubjectNumberChange.bind(this);
    this.changeReasonHandler = this.changeReasonHandler.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.updateParticipantJourney = this.updateParticipantJourney.bind(this);
  }

  handleSubjectNumberChange(event) {
    this.setState({ subjectNumber: event.target.value });
  }

  changeReasonHandler(event) {
    this.setState({ reason: event.target.value });
  }

  updateParticipantJourney(e) {
    let payload = {
      studyGid: this.state.studyGid,
      subjectNumber: this.state.subjectNumber
    };
    if (this.state.reason) {
      payload.reason = this.state.reason;
    }
    this.props.updateParticipantJourney(this.props.participantJourney.gid, payload);
    e.preventDefault();
    this.resetForm();
  }

  resetForm() {
    this.setState({
      subjectNumber: this.props.participantJourney ? this.props.participantJourney.subjectNumber : null,
      reason: ''
    });
  }

  render() {
    let body;
    if (this.props.isLoading) {
      body = <Loading />;
    } else {
      let errorBody = '';
      if (this.props.error) {
        errorBody = (
          <Row>
            <Notification type="error" data={this.props.error} />
          </Row>
        );
      }

      let reasonRequired = !!(this.props.participantJourney && this.props.participantJourney.subjectNumber);

      body = (
        <Form horizontal id="edit-participant-journey-form" onSubmit={this.updateParticipantJourney}>
          <Grid id="edit-participant-journey-grid" fluid>
            {errorBody}
            <Row>
              <FormGroup controlId="subject-number">
                <ControlLabel>{consts.STUDY_SUBJECT_NUMBER}:</ControlLabel>
                <FormControl onChange={this.handleSubjectNumberChange} required value={this.state.subjectNumber} />
              </FormGroup>
              <FormGroup controlId="reason">
                <ControlLabel>
                  {consts.CHANGE_SUBJECT_NUMBER_REASON}
                  <p className="label-details">{consts.CHANGE_SUBJECT_NUMBER_REASON_DETAILS}</p>
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  value={this.state.reason}
                  onChange={this.changeReasonHandler}
                  required={reasonRequired}
                />
              </FormGroup>
            </Row>
          </Grid>
          <div className="edit-modal-footer">
            <hr className="edit-modal-divider" />
            <Button
              id="edit-participant-journey-cancel-button"
              theme="default large-button"
              type="reset"
              handleClick={() => {
                this.props.hide();
                this.resetForm();
              }}
              label={consts.CANCEL_BTN}
            />
            <Button
              id="edit-participant-journey-save-button"
              theme="active large-button"
              type="submit"
              label={consts.SAVE_BTN}
            />
          </div>
        </Form>
      );
    }

    return <div>{body}</div>;
  }
}

ParticipantDetailsChangeModal.propTypes = {
  error: PropTypes.object,
  participantFinalStatuses: PropTypes.object,
  isLoading: PropTypes.bool,
  participantId: PropTypes.number.isRequired,
  participantJourney: PropTypes.object.isRequired,
  loadParticipantStatuses: PropTypes.func,
  resetStatus: PropTypes.func,
  saveStatus: PropTypes.func,
  hide: PropTypes.func
};

export default ParticipantDetailsChangeModal;
